import React from 'react';
import { View } from 'react-native';
import { RegularText } from 'src/components';
import { AppColors } from 'src/themes/Colors';
import { metrics } from 'src/themes/Metrics';
import styled from 'styled-components/native';

interface ButtonItemProps {
  text: string;
  fontSize?: 'huge' | 'large' | 'regular' | 'medium' | 'small' | number;
  onPress(): any;
  iconLeft?: React.ReactElement;
  iconRight?: React.ReactElement;
}

const Styled = {
  Button: styled.TouchableOpacity.attrs(() => ({
    activeOpacity: 0.8,
  }))`
    height: 40px;
    align-self: baseline;
    flex-direction: row;
    align-items: center;
    justify-content: center;
    padding-horizontal: ${metrics.small}px;
  `,
};

export const TextIconButton: React.FC<ButtonItemProps> = ({
  text,
  fontSize,
  iconLeft,
  iconRight,

  onPress,
}) => {
  return (
    <Styled.Button onPress={onPress}>
      {iconLeft || <View />}
      <RegularText
        style={{ marginLeft: metrics.small }}
        fontSize={fontSize}
        fontWeight="bold"
        color={AppColors.primary}
        textLang={text}
      />
      {iconRight || <View />}
    </Styled.Button>
  );
};
